import { render, staticRenderFns } from "./TermsOfServiceModal.vue?vue&type=template&id=044bb0c2&scoped=true&"
import script from "./TermsOfServiceModal.vue?vue&type=script&lang=js&"
export * from "./TermsOfServiceModal.vue?vue&type=script&lang=js&"
import style0 from "./TermsOfServiceModal.vue?vue&type=style&index=0&id=044bb0c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044bb0c2",
  null
  
)

export default component.exports